const CRC32_POLYNOMIAL = 0xedb88320

export { crc8 } from '../crc8'

export function crc32AuthCode(params: {
  key: readonly number[]
  data: number[]
}): number[] {
  const { key, data } = params
  if (key.length !== 4) {
    throw new Error('key must be 4 bytes.')
  }

  let crc = 0xffffffff
  for (const byte of [...key, ...data]) {
    crc = (crc ^ (byte & 0xff)) >>> 0
    for (let i = 0; i < 8; i++) {
      crc = ((crc >>> 1) ^ ((crc & 1) === 1 ? CRC32_POLYNOMIAL : 0)) >>> 0
    }
  }
  crc = (crc ^ 0xffffffff) >>> 0

  return [
    crc & 0xff,
    (crc >>> 8) & 0xff,
    (crc >>> 16) & 0xff,
    (crc >>> 24) & 0xff,
  ]
}
